{
  "familyId": "SWW-VT-ZWAK-KOF",
  "questions": [
    {
      "id": "SWW-VT-ZWAK-KOF-001",
      "familyId": "SWW-VT-ZWAK-KOF",
      "module": "SpellingWW",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "verleden_tijd",
      "subSkill": "vt_kofschip",
      "questionType": "multiple_choice",
      "question": "Gisteren ... wij in het park. (spelen)",
      "context": null,
      "options": ["speelden", "spelen", "speel", "gespeeld"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "kofschipMnemonic",
          "data": {
            "verb": "spelen",
            "stem": "speel",
            "lastLetter": "l",
            "useTE": false,
            "label": "'t Kofschip Regel"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "'t Kofschip",
            "content": "De stam 'speel' eindigt op 'l'. Deze letter staat NIET in 't kofschip, dus gebruik je -de (enkelvoud) of -den (meervoud).",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "past_tense_trigger_word_gisteren",
      "variantIndex": 1,
      "feedback": {
        "explanationText": "Regel: kofschip-regel verleden tijd. Stap 1: Bepaal de stam: spelen − en = speel. Stap 2: Kijk naar de laatste letter van de stam: 'l'. Stap 3: 'l' staat NIET in 't kofschip (T-K-O-F-S-CH-I-P), dus: speel + de = speelde (enkelvoud) of speel + den = speelden (meervoud). Stap 4: 'Wij' is meervoud, dus: speelden.",
        "distractorExplanations": {
          "0": "Correct! Kofschip-regel: 'l' niet in kofschip → stam + den (meervoud) = speelden.",
          "1": "Veelgemaakte fout: tegenwoordige tijd gebruiken in plaats van verleden tijd. 'Spelen' is de tegenwoordige tijd. Het signaalwoord 'gisteren' vraagt om verleden tijd: speelden. Misconceptie: signaalwoorden niet herkennen.",
          "2": "Veelgemaakte fout: de ik-vorm tegenwoordige tijd gebruiken. 'Speel' is de stam. Bij 'wij' in de verleden tijd moet je -den toevoegen: speelden. Misconceptie: de stam verwarren met de verleden tijd.",
          "3": "Veelgemaakte fout: voltooid deelwoord gebruiken zonder hulpwerkwoord. 'Gespeeld' hoort bij 'hebben gespeeld'. Hier is geen hulpwerkwoord, dus gewoon verleden tijd: speelden."
        }
      }
    },
    {
      "id": "SWW-VT-ZWAK-KOF-002",
      "familyId": "SWW-VT-ZWAK-KOF",
      "module": "SpellingWW",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "verleden_tijd",
      "subSkill": "vt_kofschip",
      "questionType": "fill_in",
      "question": "Vorige week ... hij de auto. (poetsen) Schrijf de juiste verleden tijd.",
      "context": null,
      "options": ["poetste"],
      "correctAnswer": 0,
      "data": {
        "acceptableAnswers": ["poetste"],
        "placeholder": "Typ het antwoord...",
        "caseSensitive": false
      },
      "stimulusAids": [
        {
          "type": "kofschipMnemonic",
          "data": {
            "verb": "poetsen",
            "stem": "poets",
            "lastLetter": "s",
            "useTE": true,
            "label": "'t Kofschip Regel"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "'t Kofschip",
            "content": "De stam 'poets' eindigt op 's'. Deze letter zit WEL in 't kofschip, dus gebruik je -te.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "past_tense_kofschip_rule",
      "variantIndex": 1,
      "feedback": {
        "explanationText": "De stam van 'poetsen' is 'poets'. De laatste letter 's' zit WEL in 't kofschip (T-K-O-F-S-CH-I-P). Daarom krijgt de verleden tijd -te: poets + te = poetste."
      }
    }
  ]
}
